import BookmakerModel from '@mediaplatform/sportal365-odds-utils/types/models/bookmaker.model';
import { defaultHandleOddProviderClick, getLabelValue } from '@sportal365/smp-widget-utils';
import { FC, useContext, useMemo } from 'react';
import { CurrencyPosition, ISubscriberInfoFn, Themes } from '../../../../types';
import { ConfigContext, SMPFlex, SMPText, styled } from '../../../index';

interface StakesFooterProps {
  amount: number;
  currency: string;
  handleClick: ISubscriberInfoFn;
  oddsBookmaker: BookmakerModel;
  theme?: Themes | null;
  currencyPosition: CurrencyPosition;
}

export const StakesFooter: FC<StakesFooterProps> = ({ amount, currency, handleClick, oddsBookmaker, theme, currencyPosition }) => {
  const { dataLabels } = useContext(ConfigContext);
  const isPrefix = currencyPosition === 'prefix';

  const stakesAmountDescription = useMemo(
    () =>
      getLabelValue(dataLabels?.stakes_amount_description, 'With a {amount} bet').replace(
        /{amount}/g,
        isPrefix ? `${currency}${amount}` : `${amount}${currency}`,
      ),
    [amount, currency, dataLabels?.stakes_amount_description, isPrefix],
  );

  const bookmakerLogo = useMemo(() => oddsBookmaker.assets[0].transparentBackgroundUrl, [oddsBookmaker.assets]);

  return (
    <SMPFlex align='center'>
      <SMPText size='2_5' variant='contrast' style={{ width: 'fit-content' }}>
        <strong>
          {stakesAmountDescription}
          &nbsp;
        </strong>
        {oddsBookmaker.stakesDisclaimer ? `| ${oddsBookmaker.stakesDisclaimer} ` : null}
        {oddsBookmaker.domainName ? `| ${oddsBookmaker.domainName}` : null}
      </SMPText>
      <BookmakerLogo
        href={oddsBookmaker.url}
        target='_blank'
        onClick={() =>
          defaultHandleOddProviderClick(handleClick, {
            id: oddsBookmaker.id,
            name: oddsBookmaker.name,
            url: oddsBookmaker.url,
          })
        }
        style={{
          backgroundImage: bookmakerLogo ? `url("${bookmakerLogo}")` : undefined,
          filter: `brightness(0)${theme === 'dark' ? ' saturate(100%) invert(1)' : ''}`,
        }}
      />
    </SMPFlex>
  );
};

const BookmakerLogo = styled.withConfig({ componentId: 'StakesWidget', displayName: 'BookmakerLogo' })('a', {
  ml: '$0',
  width: '90px',
  height: '26px',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  flexShrink: 0,
});

export default StakesFooter;
